export default __webpack_public_path__ + "static/media/PPI-pools-009.a22dd9c4.jpg";